import { EquipmentExtendedClient } from '@frontend/equipment/api';
import { EquipmentExtended } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';
import { useEffect, useMemo, useState } from 'react';

import { useScreen } from '../../../../wizard/screens/useScreen';
import { EquipmentCardProps } from './equipment-card.component';

export const useEquipmentCard = (props: EquipmentCardProps) => {
    const { navigationState } = useScreen();
    const accountId = navigationState.user?.accountId ?? navigationState.iot?.account_id;
    const [equipment, setEquipment] = useState<EquipmentExtended | undefined>(props.equipment);
    const [isLoading, setIsLoading] = useState<boolean>(!props.equipment);

    useEffect(() => {
        if (!accountId) return;
        if (props.equipment_id && !props.equipment) {
            EquipmentExtendedClient.fetchEquipmentExtended(accountId, props.equipment_id).then((equipment) => {
                setEquipment(equipment);
                setIsLoading(false);
            });
        }
    }, [accountId, props.equipment_id, props.equipment]);

    const display = useMemo(() => {
        if (!equipment) return CommonMessage.ERRORS.NOT_FOUND;
        let name = equipment.product?.data?.name ?? '';
        if (equipment.serial_number) name += ` (SN: ${equipment.serial_number})`;
        if (equipment.tag) name += ` (Tag: ${equipment.tag.name})`;
        return name;
    }, [equipment]);

    return {
        equipment,
        isLoading,
        display
    };
};
